import { ref, Ref, watch } from 'vue';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type DebouncedFunction<F extends (...args: any[]) => unknown> = ((
  ...args: Parameters<F>
) => void) & {
  cancel: () => void;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const debounce = <F extends (...args: any[]) => unknown>(
  fn: F,
  wait: number,
): DebouncedFunction<F> => {
  let timer: number | null = null;
  const debounced = ((...args: Parameters<F>) => {
    if (timer !== null) {
      window.clearTimeout(timer);
    }

    timer = window.setTimeout(() => {
      timer = null;
      fn(...args);
    }, wait);
  }) as DebouncedFunction<F>;

  debounced.cancel = () => {
    if (timer !== null) {
      window.clearTimeout(timer);
      timer = null;
    }
  };

  return debounced;
};

const toShallowRaw = <T>(value: T): T => {
  // FIXME: [...value]がT & any[]に推論されるのでas unknown as Tで回避
  if (value instanceof Array) return [...value] as unknown as T;

  if (typeof value === 'object') return { ...value };
  return value;
};

export const DebounceRef = <T>(r: Ref<T>, wait: number) => {
  const debounceRef = ref(toShallowRaw(r.value));

  watch(
    r,
    debounce(newValue => {
      debounceRef.value = toShallowRaw(newValue);
    }, wait),
    { deep: true },
  );

  return debounceRef;
};
